export default {
  global: {
    ".sb-show-main.sb-main-padded": {
      padding: 0,
    },
  },
};
